import { Navigate, Outlet } from 'react-router-dom-v5-compat';

import { ROLE_LEVELS, useAuthLevel } from '../hooks/useCurrentUser';

// Admin-only (level >= 3) route gate. Same shape as the feature gates
// (HrGate / CredentialsGate / InventoryGate / TicketsGate): a loader while the
// role hydrates, because redirecting mid-hydration bounces refreshes.
//
// Lives in app/ rather than a feature folder because it guards the whole Sistem
// group, which spans four features. The nav's `adminOnly` flag hides the menu
// entries; this is what makes typing the URL bounce too — menu visibility was
// never the boundary.
export default function AdminGate() {
    const level = useAuthLevel();

    if (level === undefined) {
        return (
            <div className="flex h-64 w-full items-center justify-center text-sm text-gray-500 dark:text-gray-400">
                Se incarca...
            </div>
        );
    }
    if (level < ROLE_LEVELS.ADMIN) return <Navigate to="/v2/dashboard" replace />;
    return <Outlet />;
}
